<template>
  <div>
    <list-layout
      :can-operate="canOperate"
      :column-default-selected="columnDefaultSelected"
      :columns-all="columnsAll"
      :default-selected="tableDefaultSelectData"
      :export-func="exportFunc"
      :get-table-data-func="getTableDataFunc"
      :group-tree-func="groupTreeFunc"
      :in-modal="inModal"
      :refresh="updateTableFlag"
      :customer-params="params"
      :search-type-options="[
        { label: '名称', value: 'name' },
        { label: 'IP 地址', value: 'monitor_address' }
      ]"
      :table-operation-width="tableOperationWidth"
      :tools-list="toolsList"
      @tableSelectData="getSelectData"
      sourceType="security"
      :apiPermission="groupApiPermission"
      :can-drag-column-width="true"
    >
      <template #leftTool>
        <create-button v-permission="{action: 'base.network_device.create', effect: 'disabled'}"
          @click="
            () => {
              if (deviceType === 'terminal') $refs.terminalInputDrawer.show()
              else $refs.inputDrawer.show()
            }
          "></create-button>
      </template>
      <!-- 表格自定义列 -->
      <template #name="{ slotProps }">
        <a-tooltip placement="topLeft" :title="slotProps.text">
          <a
            @click="
              () => {
                if (slotProps.record.device_type === 'switch') {
                  $refs.switchDrawer.show(slotProps.record.id)
                } else if (
                  slotProps.record.device_type === 'firewall' ||
                  slotProps.record.device_type === 'load_balancer' ||
                  slotProps.record.device_type === 'security'
                ) {
                  $refs.securityDrawer.show(slotProps.record.id)
                } else if (slotProps.record.device_type === 'terminal') {
                  $refs.terminalDrawer.show(slotProps.record.id)
                } else {
                  $refs.detailDrawer.show(slotProps.record.id)
                }
              }
            "
            v-if="link"
          >
            {{ slotProps.text }}
          </a>
          <span v-else>{{ slotProps.text }}</span>
        </a-tooltip>
      </template>
      <template #deviceType="{ slotProps }">
        {{ $t(`network_device_type.${slotProps.text}`) }}
      </template>
      <template #snmpVersion="{ slotProps }">
        {{ $t(`snmp_version.${slotProps.text}`) }}
      </template>
      <template #vendor="{ slotProps }">
        {{ $t(`hardware_vendor.${slotProps.text}`) }}
      </template>
      <template #statusTitle>
        <status-question-icon></status-question-icon>
      </template>
      <template #status="{ slotProps }">
        <source-status-tag :status="slotProps.text"></source-status-tag>
      </template>
      <template #operation="{ slotProps }">
        <sync-button @click="sync(slotProps.record.id)"></sync-button>
        <a-dropdown>
          <a-button icon="more" size="small" type="link" style="color: #faad14">
            更多
          </a-button>
          <a-menu slot="overlay">
            <a-menu-item key="edit">
              <edit-button
              v-permission="{action: 'base.network_device.update', effect: 'disabled'}"
                @click="
                  () => {
                    if (deviceType === 'terminal')
                      $refs.terminalInputDrawer.show(slotProps.record.id)
                    else $refs.inputDrawer.show(slotProps.record.id)
                  }
                "
              ></edit-button>
            </a-menu-item>
            <a-menu-item key="clone">
              <clone-button
                @click="
                  () => {
                    if (deviceType === 'terminal')
                      $refs.terminalInputDrawer.show(slotProps.record.id, true)
                    else $refs.inputDrawer.show(slotProps.record.id, true)
                  }
                "
              ></clone-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <delete-button v-permission="{action: 'base.network_device.delete', effect: 'disabled'}" @confirm="confirm(slotProps.record.id)"></delete-button>
      </template>
    </list-layout>

    <network-device-drawer ref="detailDrawer"></network-device-drawer>
    <switch-drawer ref="switchDrawer"></switch-drawer>
    <security-drawer ref="securityDrawer"></security-drawer>
    <terminal-drawer ref="terminalDrawer"></terminal-drawer>

    <terminal-input-drawer
      ref="terminalInputDrawer"
      @ok="confirm"
    ></terminal-input-drawer>
    <hardware-input-drawer
      ref="inputDrawer"
      source-type="network_device"
      :device-type="deviceType"
      :isSimple="isSimple"
      @ok="confirm"
    ></hardware-input-drawer>
  </div>
</template>

<script>
import {
  createNetworkDeviceGroup,
  deleteNetworkDevice,
  deleteNetworkDeviceGroup,
  exportNetworkDevice,
  getNetworkDeviceGroup,
  getNetworkDeviceGroupList,
  getNetworkDeviceList,
  syncNetworkDevice,
  updateNetworkDeviceGroup
} from '@/api/network-device'
import ListLayout from '@/components/ListLayout'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'
import CreateButton from '@/components/button/CreateButton'
import SyncButton from '@/components/button/SyncButton'
import StatusQuestionIcon from '@/components/icon/StatusQuestionIcon'
import SourceStatusTag from '@/components/tag/SourceStatusTag'
import { sourceStatuses, securityType, switchVendors } from '@/utils/const'
import CloneButton from '@/components/button/CloneButton'
import TerminalInputDrawer from '@/components/drawer/TerminalInputDrawer'
import SwitchDrawer from '@/components/drawer/SwitchDrawer'
import SecurityDrawer from '@/components/drawer/SecurityDrawer'
import TerminalDrawer from '@/components/drawer/TerminalDrawer'
import { hasPermission } from '@/utils'

export default {
  name: 'NetworkDeviceTable',
  components: {
    DeleteButton,
    EditButton,
    HardwareInputDrawer: () =>
      import('@/components/drawer/HardwareInputDrawer'),
    ListLayout,
    NetworkDeviceDrawer: () =>
      import('@/components/drawer/NetworkDeviceDrawer'),
    SourceStatusTag,
    StatusQuestionIcon,
    SyncButton,
    CloneButton,
    TerminalInputDrawer,
    SwitchDrawer,
    SecurityDrawer,
    CreateButton,
    TerminalDrawer
  },
  props: {
    defaultSelected: {
      type: Array
    },
    toolsList: {
      type: Array,
      default: () => []
    },
    tableOperationWidth: {
      type: Number,
      default: 240
    },
    link: {
      type: Boolean,
      default: true
    },
    refresh: {
      type: Boolean
    },
    canOperate: {
      type: Boolean,
      default: true
    },
    inModal: {
      type: Boolean,
      default: false
    },
    isSimple: {
      type: Boolean,
      default: false
    },
    fetchParams: {
      type: Object
    },
    deviceType: {
      type: [String, Array]
    }
  },
  data () {
    return {
      getTableDataFunc: getNetworkDeviceList,
      exportFunc: exportNetworkDevice,
      columnDefaultSelected: [
        'name',
        'device_type',
        'monitor_address',
        'vendor',
        'model',
        'status'
      ],
      updateTableFlag: this.refresh,
      customerParams: this.$route.params,
      tableSelectData: [],
      tableDefaultSelectData: [],
      groupApiPermission: {
        create: 'base.network_device_group.create',
        edit: 'base.network_device_group.update',
        delete: 'base.network_device_group.delete'
      }
    }
  },
  computed: {
    columnsAll () {
      let deviceTypeObj = {
        dataIndex: 'device_type',
        title: '设备类型',
        width: 100,
        scopedSlots: {
          customRender: 'deviceType'
        }
      }

      const vendorObj =
        this.deviceType === 'switch' ? {
          dataIndex: 'vendor',
          title: '制造商',
          width: 100,
          scopedSlots: {
            customRender: 'vendor'
          },
          filteredValue: [],
          filters: switchVendors.map(value => {
            return {
              text: this.$t(`hardware_vendor.${value}`),
              value
            }
          }),
          filterMultiple: false
        } : {
          dataIndex: 'vendor',
          title: '制造商',
          width: 100,
          scopedSlots: {
            customRender: 'vendor'
          }
        }

      if (Array.isArray(this.deviceType)) {
        deviceTypeObj = {
          dataIndex: 'device_type',
          title: '设备类型',
          width: 100,
          scopedSlots: {
            customRender: 'deviceType'
          },
          filteredValue: [],
          filters: securityType.map(value => {
            return {
              text: this.$t(`network_device_type.${value}`),
              value
            }
          }),
          filterMultiple: false
        }
      } else if (this.deviceType === 'terminal') {
        return [
          {
            dataIndex: 'name',
            title: '名称',
            fixed: 'left',
            width: 150,
            ellipsis: true,
            scopedSlots: {
              customRender: 'name'
            }
          },
          {
            dataIndex: 'hostname',
            title: '英文名称',
            width: 150,
            ellipsis: true,
            scopedSlots: {
              customRender: 'hostname'
            }
          },
          {
            dataIndex: 'device_type',
            title: '设备类型',
            width: 100,
            scopedSlots: {
              customRender: 'deviceType'
            }
          },
          {
            dataIndex: 'monitor_address',
            title: 'IP 地址',
            width: 160,
            scopedSlots: {
              customRender: 'monitorAddress'
            }
          },
          {
            dataIndex: 'monitor_port',
            title: '监控端口',
            width: 100,
            scopedSlots: {
              customRender: 'monitorPort'
            }
          },
          {
            dataIndex: 'snmp_version',
            title: 'SNMP 版本',
            width: 120,
            scopedSlots: {
              customRender: 'snmpVersion'
            }
          },
          {
            dataIndex: 'vendor',
            title: '制造商',
            width: 100,
            scopedSlots: {
              customRender: 'vendor'
            }
          },
          {
            dataIndex: 'status',
            width: 100,
            slots: {
              title: 'statusTitle',
              name: '状态'
            },
            scopedSlots: {
              customRender: 'status'
            },
            filteredValue: [],
            filters: sourceStatuses.map(value => {
              return {
                text: this.$t(`source_status.${value}`),
                value
              }
            }),
            filterMultiple: false
          },
          {
            dataIndex: 'created_at',
            title: '创建时间',
            width: 200
          },
          {
            dataIndex: 'updated_at',
            title: '更新时间',
            width: 200
          }
        ]
      }

      return [
        {
          dataIndex: 'name',
          title: '名称',
          fixed: 'left',
          width: 190,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'hostname',
          title: '英文名称',
          width: 190,
          ellipsis: true,
          scopedSlots: {
            customRender: 'hostname'
          }
        },
        deviceTypeObj,
        {
          dataIndex: 'monitor_address',
          title: 'IP 地址',
          width: 160,
          scopedSlots: {
            customRender: 'monitorAddress'
          }
        },
        {
          dataIndex: 'monitor_port',
          title: '监控端口',
          width: 100,
          scopedSlots: {
            customRender: 'monitorPort'
          }
        },
        {
          dataIndex: 'snmp_version',
          title: 'SNMP 版本',
          width: 120,
          scopedSlots: {
            customRender: 'snmpVersion'
          }
        },
        vendorObj,
        {
          dataIndex: 'model',
          title: '型号',
          width: 130,
          ellipsis: true,
          scopedSlots: {
            customRender: 'model'
          }
        },
        {
          dataIndex: 'firmware_version',
          title: '固件版本',
          width: 100,
          ellipsis: true,
          scopedSlots: {
            customRender: 'firmwareVersion'
          }
        },
        {
          dataIndex: 'serial_number',
          title: 'SN',
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serialNumber'
          }
        },
        {
          dataIndex: 'status',
          width: 100,
          slots: {
            title: 'statusTitle',
            name: '状态'
          },
          scopedSlots: {
            customRender: 'status'
          },
          filteredValue: [],
          filters: sourceStatuses.map(value => {
            return {
              text: this.$t(`source_status.${value}`),
              value
            }
          }),
          filterMultiple: false
        },
        {
          dataIndex: 'created_at',
          title: '创建时间',
          width: 200
        },
        {
          dataIndex: 'updated_at',
          title: '更新时间',
          width: 200
        }
      ]
    },
    params () {
      const obj = {}
      for (const key in this.customerParams) {
        if (Object.hasOwnProperty.call(this.customerParams, key)) {
          obj[key] = this.customerParams[key]
        }
      }
      for (const key in this.fetchParams) {
        if (Object.hasOwnProperty.call(this.fetchParams, key)) {
          obj[key] = this.fetchParams[key]
        }
      }
      this.columnsAll.forEach(column => {
        if (Object.hasOwnProperty.call(column, 'filteredValue')) {
          if (
            Object.hasOwnProperty.call(obj, column.dataIndex) &&
            ((Array.isArray(this.deviceType) &&
              obj.device_type.toString() !== this.deviceType.toString()) ||
              !Array.isArray(this.deviceType))
          ) {
            column.filteredValue = [obj[column.dataIndex]]
          } else column.filteredValue = []
        }
      })
      return obj
    },
    groupTreeFunc () {
      if (hasPermission(['base.network_device_group.view'])) {
        return {
          createFunc: createNetworkDeviceGroup,
          deleteFunc: deleteNetworkDeviceGroup,
          getFunc: getNetworkDeviceGroup,
          getListFunc: getNetworkDeviceGroupList,
          updateFunc: updateNetworkDeviceGroup
        }
      } else return null
    }
  },
  mounted () {
    if (this.defaultSelected) this.tableDefaultSelectData = this.defaultSelected
  },
  methods: {
    getSelectData (data) {
      this.tableSelectData = data
      this.$emit('selectedData', data)
    },
    async confirm (id = '') {
      if (id) {
        await deleteNetworkDevice(id).then(res => {
          this.$message.success(res.message)
        })
        this.tableSelectData.splice(
          this.tableSelectData.findIndex(item => item.key === id),
          1
        )
        this.tableDefaultSelectData = this.tableSelectData
        this.$emit('selectedData', this.tableSelectData)
      }
      this.updateTableFlag = !this.updateTableFlag
    },
    sync (id) {
      syncNetworkDevice({ id }).then(res => {
        this.$message.success(res.message)
      })
    },
    monitor () {
      this.$refs.inputDrawer.show()
    }
  },
  watch: {
    refresh (v) {
      this.updateTableFlag = v
    }
  }
}
</script>
